(() => {
  'use strict';

  const normalizeKey = (value) => String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  const initIngredientFilters = (root) => {
    if (!root || root.dataset.lov2bHomeReady === 'true') return;
    root.dataset.lov2bHomeReady = 'true';

    const buttons = Array.from(root.querySelectorAll('[data-home-filter]'));
    const cards = Array.from(root.querySelectorAll('[data-home-categories]'));
    if (!buttons.length || !cards.length) return;

    const applyFilter = (rawKey) => {
      const key = normalizeKey(rawKey) || 'all';

      buttons.forEach((button) => {
        const isActive = normalizeKey(button.dataset.homeFilter) === key;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });

      cards.forEach((card) => {
        const categories = (card.dataset.homeCategories || '')
          .split('|')
          .map(normalizeKey)
          .filter(Boolean);

        const isVisible = key === 'all' || categories.some((category) => (
          category === key || category.startsWith(`${key}-`) || category.includes(key)
        ));

        card.hidden = !isVisible;
      });
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => applyFilter(button.dataset.homeFilter));
    });
  };

  const init = (scope = document) => {
    const roots = scope.matches?.('[data-lov2b-home-ingredients]')
      ? [scope]
      : Array.from(scope.querySelectorAll?.('[data-lov2b-home-ingredients]') || []);

    roots.forEach(initIngredientFilters);
  };

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
